import { useRequest } from 'ahooks'
import { Form, Modal } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { JQLEditContent } from '@/components/jql/jql-edit-content.component'
import { Project, ResourceType } from '@/schemas'

import { JiraColumnProps } from './project-jql-table-config.component'

interface ProjectJQLEditProps {
  columns: JiraColumnProps[]
  selfId: string
  jql?: string | null
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  onSuccess: (jql: string) => void
  project: Project
}

export const ProjectJQLEdit: React.FC<ProjectJQLEditProps> = ({
  selfId,
  jql,
  visible,
  setVisible,
  onSuccess,
  columns,
  project,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const { run, loading } = useRequest(
    (jql) => ({
      url: '/api/project/updateProject',
      method: 'patch',
      data: {
        selfId,
        jql,
      },
    }),
    {
      manual: true,
      onSuccess: (_, [jql]) => {
        onSuccess(jql)
        setVisible(false)
      },
    }
  )

  const onOk = () => {
    form.submit()
  }

  return (
    <Modal
      title={t('configure jql')}
      width='80vw'
      okText={t('save')}
      visible={visible}
      onOk={onOk}
      onCancel={() => setVisible(false)}
      okButtonProps={{ loading }}
    >
      <JQLEditContent
        form={form}
        jql={jql}
        onSubmit={run}
        columns={columns}
        entity={{ name: project.name, type: ResourceType.PROJECT }}
      />
    </Modal>
  )
}
